import React from 'react'
import PropTypes from 'prop-types'
import BaseIcon from '../../BaseIcon/BaseIcon'
import { ReactComponent as Component } from './Facebook.svg'

const Facebook = ({ className }) => {
	return <BaseIcon component={Component} className={className} viewBox="0 0 320 512" />
}

Facebook.propTypes = {
	className: PropTypes.string,
}

export default Facebook
